
export const dashboardBaseUrl = "/dashboard"
export const dashboardConstUrl = {
    dashboardUrl: `${dashboardBaseUrl}`,
    upcomingBirthdaysUrl:`${dashboardBaseUrl}/upcoming-birthdays`,
    employeeOnLeavesUrl : `${dashboardBaseUrl}/employee-on-leaves`,
    workAnniversariesUrl : `${dashboardBaseUrl}/work-anniversaries`,
    upcomingRenewalContractsUrl : `${dashboardBaseUrl}/upcoming-renewal-contracts`,
    holiDaysUrl : `${dashboardBaseUrl}/holidays`,

}